import { render, staticRenderFns } from "./KeyFeatureItemsDesktop.vue?vue&type=template&id=6b068835&scoped=true&"
import script from "./KeyFeatureItemsDesktop.vue?vue&type=script&lang=js&"
export * from "./KeyFeatureItemsDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b068835",
  null
  
)

export default component.exports